import styles from "./index.module.css";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJs,
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { getSalePaymnets } from "../../redux/features/dashboard/dashboardService";
import { useEffect, useMemo } from "react";
import moment from "moment";

ChartJs.register(
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ chartTitle }) => {
  const dispatch = useDispatch();

  const { isSalePaymentsLoading, payments } = useSelector(
    (state) => state.dashboard.salePayments
  );

  useEffect(() => {
    dispatch(getSalePaymnets({}));
  }, [dispatch]);

  const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'short' }); 
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 100,
        },
      },
    },
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardTopic}>
        <p className={styles.title}>{chartTitle}</p>
      </div>
      <div className={styles.barChart}>
      <Bar
          options={options}
          data={{
            labels: payments?.map((item) => getDayName(item.day)) || [],
            datasets: [
              {
                label: "Income",
                backgroundColor: "#fcbf00",
                barThickness: 20,
                borderRadius: 4,
                borderSkipped: false,
                data: payments?.map((item) => Number(item.sold_count)) || [],
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default BarChart;